import React from 'react';
import { FiArrowUp, FiArrowDown } from 'react-icons/fi';

const SortableHeader = ({ label, sortKey, currentSortKey, currentSortOrder, onSort, icon: Icon }) => {
  const isSorted = currentSortKey === sortKey;

  const handleClick = () => {
    if (onSort && sortKey) {
      onSort(sortKey);
    }
  };

  return (
    <div 
      className={`flex items-center gap-1.5 ${sortKey ? 'cursor-pointer hover:text-gray-700 select-none' : ''}`}
      onClick={handleClick}
    >
      {Icon && <Icon className="w-3.5 h-3.5 text-gray-400" />}
      <span>{label}</span>
      {sortKey && (
        <span className="flex flex-col ml-1">
          <FiArrowUp 
            className={`w-3 h-3 -mb-1 ${isSorted && currentSortOrder === 'asc' ? 'text-[#715EFE]' : 'text-gray-300'}`} 
          />
          <FiArrowDown 
            className={`w-3 h-3 ${isSorted && currentSortOrder === 'desc' ? 'text-[#715EFE]' : 'text-gray-300'}`} 
          />
        </span>
      )}
    </div>
  );
};

export default SortableHeader;
